import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaffTableComponent } from './staff-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NgxMaskModule } from 'ngx-mask';



@NgModule({
  declarations: [StaffTableComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    NgxMaskModule
  ],
  exports: [StaffTableComponent]
})
export class StaffTableModule { }
